import React          from 'react';
import { words }      from '../utils/dictionary';
import colors         from '../utils/colors';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
       width:           150,
       marginLeft:      10,
       height:          '100%',
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       textAlign:       'center',
       fontSize:        23,
       color:           colors.dark,
       cursor:          'pointer',
       '&:hover': {
          color: colors.blue
       }
    }
}))

type SignOutButtonProps = {
   lang:   string;
   logOut: () => void;
}

const SignOutButton: React.FC<SignOutButtonProps> = ({ lang, logOut }) => {

  const classes = useStyles();

  return (
    <div 
      dir       = 'rtl'
      className = { classes.root }
      onClick   = { logOut }
    >
      { `${ words['signOut'][lang] }` }
    </div>
  );
}


export default SignOutButton;